import type { ServiceSettings } from '@witmetrics/unison-core';
import { searchByKeys } from '@witmetrics/utils/arrays';

export const classes = {
  tab: 'p-4 h-full flex flex-col gap-4',
  loading: 'place-center h-32',
  noSettings: 'p-4 text-sm text-grey-7 dark:text-mauve-2',
  searchField: 'mb-4',
  viewButton:
    'mt-1 text-blue-3 font-semibold text-sm cursor-pointer hover:underline',
  listItem: 'mb-4 text-sm',
};

export function filterSettings(settings: ServiceSettings, search: string) {
  return searchByKeys(buildSettings(settings), ['label', 'value'], search);
}

function buildSettings(settings: ServiceSettings) {
  return Object.keys(settings).map((key) => ({
    key,
    ...settings[key],
  }));
}
